import React, { forwardRef } from "react";
import moment from "moment";
import { startOfMonth, startOfWeek, addDays, addWeeks, isSameDay } from "date-fns";
import classNames from "classnames";
import { ArrowForwardIos, ArrowBackIos } from "../../icons";
import { onEnter } from "../../helpers";
import { isWithinRange } from "./utils";
function getIsWithinRangeFromStartAndEndDates(_ref) {
  let {
    startDay,
    endDay: endDate,
    minDate,
    maxDate
  } = _ref;
  const shouldCheck = !isWithinRange(startDay, minDate, maxDate) || !isWithinRange(endDate, minDate, maxDate);
  return date => {
    if (shouldCheck) return isWithinRange(date, minDate, maxDate);
    return true;
  };
}
const DAYS_IN_WEEK = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const CalendarDisplay = /*#__PURE__*/forwardRef((props, ref) => {
  function renderDays() {
    const month = props.date.getMonth();
    const MONDAY = 1;
    const startDay = startOfWeek(startOfMonth(props.date), {
      weekStartsOn: MONDAY
    });
    const WEEKS_TO_DISPLAY = 6;
    const endDay = addWeeks(startDay, WEEKS_TO_DISPLAY);
    const today = new Date();
    const isWithinRange = getIsWithinRangeFromStartAndEndDates({
      startDay,
      endDay,
      minDate: props.minDate,
      maxDate: props.maxDate
    });
    const days = [];
    let currDay = new Date(startDay);
    while (currDay < endDay) {
      const day = new Date(currDay);
      const DAYS_TO_ADD = 1;
      currDay = addDays(currDay, DAYS_TO_ADD);
      const isEnabled = isWithinRange(day);
      const onClick = () => {
        if (!isEnabled) return false;
        props.onChange(day);
      };
      days.push(/*#__PURE__*/React.createElement("div", {
        key: day.getTime(),
        role: "button",
        tabIndex: -1,
        "aria-disabled": !isEnabled,
        className: classNames("tui-date-picker__calendar-display__day", {
          "tui-date-picker__calendar-display__day--other-month": month !== day.getMonth(),
          "tui-date-picker__calendar-display__day--current": isSameDay(day, props.selectedDate),
          "tui-date-picker__calendar-display__day--today": isSameDay(day, today)
        }),
        onClick: onClick,
        onKeyPress: onEnter(onClick)
      }, day.getDate()));
    }
    return days;
  }
  return /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    "aria-hidden": !props.show,
    tabIndex: -1,
    ref: ref,
    className: `tui-date-picker__calendar-display ${props.alwaysShowCalendar ? "tui-date-picker__calendar-display--inline-cal" : ""}`,
    style: {
      display: props.show ? undefined : "none"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__calendar-display__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__calendar-display__date"
  }, moment(props.date).format("MMMM YYYY")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    tabIndex: -1,
    type: "button",
    "aria-label": "Previous month",
    onClick: props.prevMonth
  }, /*#__PURE__*/React.createElement(ArrowBackIos, null)), /*#__PURE__*/React.createElement("button", {
    tabIndex: -1,
    type: "button",
    "aria-label": "Next month",
    onClick: props.nextMonth
  }, /*#__PURE__*/React.createElement(ArrowForwardIos, null)))), /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__calendar-display__days"
  }, DAYS_IN_WEEK.map(day => /*#__PURE__*/React.createElement("span", {
    className: "tui-date-picker__calendar-display__day tui-date-picker__calendar-display__dow",
    key: day
  }, day[0])), renderDays()));
});
CalendarDisplay.displayName = "CalendarDisplay";
//# sourceMappingURL=CalendarDisplay.js.map